/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IIdentity
 */
export interface IIdentity {
    /**
     * 
     * @type {string}
     * @memberof IIdentity
     */
    readonly name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IIdentity
     */
    readonly authenticationType?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IIdentity
     */
    readonly isAuthenticated?: boolean;
}

/**
 * Check if a given object implements the IIdentity interface.
 */
export function instanceOfIIdentity(value: object): value is IIdentity {
    return true;
}

export function IIdentityFromJSON(json: any): IIdentity {
    return IIdentityFromJSONTyped(json, false);
}

export function IIdentityFromJSONTyped(json: any, ignoreDiscriminator: boolean): IIdentity {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'authenticationType': json['authenticationType'] == null ? undefined : json['authenticationType'],
        'isAuthenticated': json['isAuthenticated'] == null ? undefined : json['isAuthenticated'],
    };
}

export function IIdentityToJSON(json: any): IIdentity {
    return IIdentityToJSONTyped(json, false);
}

export function IIdentityToJSONTyped(value?: Omit<IIdentity, 'name'|'authenticationType'|'isAuthenticated'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
    };
}

